// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"_89b4965636--collapsed--ZnFZc","expandable":"_89b4965636--expandable--nDfVT"};